var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconProphetes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "moon_6_",
    "data-name": "moon (6)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_16024",
    "data-name": "Path 16024",
    d: "M80.662,40.683A39.482,39.482,0,0,1,8.138,62.292.816.816,0,0,1,9.161,61.1,39.5,39.5,0,0,0,61.6,8.661a.816.816,0,0,1,1.191-1.023A39.442,39.442,0,0,1,80.662,40.683Zm0,0",
    transform: "translate(-6.823 -6.323)",
    fill: "#fed370"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16025",
    "data-name": "Path 16025",
    d: "M96.776,56.8A39.473,39.473,0,0,1,27.109,82.229,39.473,39.473,0,0,0,82.729,26.609,39.383,39.383,0,0,1,96.776,56.8Zm0,0",
    transform: "translate(-22.937 -22.437)",
    fill: "#fda736"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16026",
    "data-name": "Path 16026",
    d: "M459.962,175.423a1.179,1.179,0,0,1-1.145-1.45,38.572,38.572,0,0,0,.048-17.7,1.176,1.176,0,0,1,2.291-.534,40.936,40.936,0,0,1-.051,18.784A1.177,1.177,0,0,1,459.962,175.423Zm0,0",
    transform: "translate(-387.207 -130.666)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16027",
    "data-name": "Path 16027",
    d: "M34.855,331.483h0A40.521,40.521,0,0,1,.831,313.012a1.989,1.989,0,0,1,.158-2.4,1.963,1.963,0,0,1,2.339-.5,37.866,37.866,0,0,0,14.507,3.526,1.176,1.176,0,0,1-.1,2.35,40.194,40.194,0,0,1-14.252-3.23,38.28,38.28,0,0,0,67.079-8.176,1.172,1.172,0,1,1,2.182.855,40.882,40.882,0,0,1-14.708,18.732A40.212,40.212,0,0,1,34.855,331.483Zm0,0",
    transform: "translate(-0.5 -256.468)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16028",
    "data-name": "Path 16028",
    d: "M137.5,59.686a1.176,1.176,0,0,1-.1-2.348,38.37,38.37,0,0,0,35.109-38.311A38.129,38.129,0,0,0,168.95,2.839,1.995,1.995,0,0,1,171.856.332a41.2,41.2,0,0,1,15.79,19.58,1.176,1.176,0,1,1-2.2.84A38.842,38.842,0,0,0,171.6,3a40.93,40.93,0,0,1-7.514,43.71A40.645,40.645,0,0,1,137.6,59.682C137.57,59.684,137.536,59.686,137.5,59.686Zm0,0",
    transform: "translate(-115.312 0)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16029",
    "data-name": "Path 16029",
    d: "M83.469,225.849h-.006a1.176,1.176,0,0,1-1.17-1.182l0-.446a1.176,1.176,0,0,1,1.176-1.17h.006a1.176,1.176,0,0,1,1.17,1.182l0,.446A1.176,1.176,0,0,1,83.469,225.849Zm0,0",
    transform: "translate(-69.468 -188.204)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16030",
    "data-name": "Path 16030",
    d: "M83.379,254.794h-.005a1.177,1.177,0,0,1-1.171-1.182l0-.445A1.176,1.176,0,0,1,83.381,252h.006a1.176,1.176,0,0,1,1.17,1.181l0,.446A1.176,1.176,0,0,1,83.379,254.794Zm0,0",
    transform: "translate(-69.392 -212.627)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16031",
    "data-name": "Path 16031",
    d: "M96.927,241.335h-.006l-.446,0a1.176,1.176,0,0,1,.006-2.352h.005l.446,0a1.176,1.176,0,0,1-.006,2.352Zm0,0",
    transform: "translate(-80.493 -201.644)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16032",
    "data-name": "Path 16032",
    d: "M67.985,241.245h-.006l-.446,0a1.176,1.176,0,0,1,.006-2.352h.006l.446,0a1.176,1.176,0,0,1-.006,2.352Zm0,0",
    transform: "translate(-56.036 -201.568)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16033",
    "data-name": "Path 16033",
    d: "M159.129,183.192h-.006a1.176,1.176,0,0,1-1.171-1.181l0-.446a1.175,1.175,0,0,1,1.175-1.171h.006a1.177,1.177,0,0,1,1.171,1.182l0,.446A1.176,1.176,0,0,1,159.129,183.192Zm0,0",
    transform: "translate(-133.354 -152.211)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16034",
    "data-name": "Path 16034",
    d: "M159.039,212.138h-.005a1.176,1.176,0,0,1-1.17-1.182l0-.445a1.176,1.176,0,0,1,1.175-1.17h.006a1.176,1.176,0,0,1,1.171,1.181l0,.446A1.176,1.176,0,0,1,159.039,212.138Zm0,0",
    transform: "translate(-133.278 -176.635)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16035",
    "data-name": "Path 16035",
    d: "M172.587,198.682h-.006l-.446,0a1.176,1.176,0,0,1,.005-2.352h.006l.446,0a1.176,1.176,0,0,1-.005,2.352Zm0,0",
    transform: "translate(-144.333 -165.655)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16036",
    "data-name": "Path 16036",
    d: "M143.645,198.592h-.006l-.445,0a1.176,1.176,0,0,1,.011-2.352l.446,0a1.176,1.176,0,0,1-.006,2.352Zm0,0",
    transform: "translate(-119.913 -165.579)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16037",
    "data-name": "Path 16037",
    d: "M466.926,365.493h-.006a1.176,1.176,0,0,1-1.17-1.182l0-.446a1.176,1.176,0,0,1,1.176-1.17h.006a1.175,1.175,0,0,1,1.17,1.181l0,.446A1.176,1.176,0,0,1,466.926,365.493Zm0,0",
    transform: "translate(-393.08 -306.031)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16038",
    "data-name": "Path 16038",
    d: "M466.836,394.435h-.006a1.176,1.176,0,0,1-1.17-1.182l0-.446a1.176,1.176,0,0,1,1.175-1.17h.006a1.176,1.176,0,0,1,1.171,1.182l0,.446A1.176,1.176,0,0,1,466.836,394.435Zm0,0",
    transform: "translate(-393.005 -330.451)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16039",
    "data-name": "Path 16039",
    d: "M480.384,380.979h-.005l-.446,0a1.176,1.176,0,0,1,.005-2.352h.005l.446,0a1.176,1.176,0,0,1-.005,2.352Zm0,0",
    transform: "translate(-404.052 -319.471)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16040",
    "data-name": "Path 16040",
    d: "M451.439,380.89h-.006l-.446,0a1.176,1.176,0,0,1,.005-2.352H451l.447,0a1.176,1.176,0,0,1-.005,2.352Zm0,0",
    transform: "translate(-379.645 -319.395)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16041",
    "data-name": "Path 16041",
    d: "M81.52,468.009h-.006a1.176,1.176,0,0,1-1.171-1.182l0-.446a1.176,1.176,0,0,1,1.176-1.17h.006a1.177,1.177,0,0,1,1.17,1.182l0,.446A1.176,1.176,0,0,1,81.52,468.009Zm0,0",
    transform: "translate(-67.824 -392.547)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16042",
    "data-name": "Path 16042",
    d: "M81.434,496.954h-.006a1.176,1.176,0,0,1-1.17-1.182l0-.446a1.176,1.176,0,0,1,1.176-1.17h.006a1.176,1.176,0,0,1,1.17,1.182l0,.446A1.176,1.176,0,0,1,81.434,496.954Zm0,0",
    transform: "translate(-67.752 -416.954)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16043",
    "data-name": "Path 16043",
    d: "M94.981,483.5h-.006l-.446,0a1.176,1.176,0,0,1,.006-2.352h.006l.446,0a1.176,1.176,0,0,1-.006,2.352Zm0,0",
    transform: "translate(-78.852 -405.983)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16044",
    "data-name": "Path 16044",
    d: "M66.036,483.409H66.03l-.446,0a1.176,1.176,0,0,1,.006-2.352H65.6l.446,0a1.176,1.176,0,0,1-.006,2.352Zm0,0",
    transform: "translate(-54.392 -405.907)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16045",
    "data-name": "Path 16045",
    d: "M482.82,11.2h-.005a1.176,1.176,0,0,1-1.171-1.182l0-.446a1.176,1.176,0,0,1,1.176-1.17h.006A1.176,1.176,0,0,1,484,9.58l0,.446A1.176,1.176,0,0,1,482.82,11.2Zm0,0",
    transform: "translate(-406.483 -7.082)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16046",
    "data-name": "Path 16046",
    d: "M482.731,40.142h-.006a1.176,1.176,0,0,1-1.17-1.182l0-.445a1.176,1.176,0,0,1,1.176-1.17h.006a1.176,1.176,0,0,1,1.17,1.182l0,.446A1.176,1.176,0,0,1,482.731,40.142Zm0,0",
    transform: "translate(-406.407 -31.488)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16047",
    "data-name": "Path 16047",
    d: "M496.278,26.683h-.006l-.446,0a1.176,1.176,0,0,1,.006-2.352h.006l.446,0a1.176,1.176,0,0,1-.005,2.352Zm0,0",
    transform: "translate(-417.454 -20.514)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16048",
    "data-name": "Path 16048",
    d: "M467.333,26.6h-.006l-.446,0a1.176,1.176,0,0,1,.005-2.352h.006l.446,0a1.176,1.176,0,0,1-.005,2.352Zm0,0",
    transform: "translate(-393.047 -20.441)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16049",
    "data-name": "Path 16049",
    d: "M473.272,87.114h-.023a1.176,1.176,0,0,1,0-2.352h.023a1.176,1.176,0,0,1,0,2.352Zm0,0",
    transform: "translate(-398.416 -71.471)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16050",
    "data-name": "Path 16050",
    d: "M289.905,136.422h-.018a1.176,1.176,0,1,1,0-2.352h.018a1.176,1.176,0,0,1,0,2.352Zm0,0",
    transform: "translate(-243.683 -113.124)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16051",
    "data-name": "Path 16051",
    d: "M365.108,460.11h-.018a1.176,1.176,0,0,1,0-2.352h.018a1.176,1.176,0,0,1,0,2.352Zm0,0",
    transform: "translate(-307.137 -386.263)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16052",
    "data-name": "Path 16052",
    d: "M170.769,255.524h-.023a1.176,1.176,0,0,1,0-2.352h.023a1.176,1.176,0,0,1,0,2.352Zm0,0",
    transform: "translate(-143.159 -213.618)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16053",
    "data-name": "Path 16053",
    d: "M155.261,298.832h-.023a1.176,1.176,0,0,1,0-2.352h.023a1.176,1.176,0,0,1,0,2.352Zm0,0",
    transform: "translate(-130.074 -250.16)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProphetes);
export default __webpack_public_path__ + "static/media/icon-prophetes.570e3bec.svg";
export { ForwardRef as ReactComponent };